<template>
  <footer>INESC TEC - All Rights Reserved 2025</footer>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      pages: null
    };
  }
};
</script>

<style lang="scss">
footer {
  background-color: $dark-color;
  padding: 2em 5em;
  color: white;
  @include media-breakpoint-down(md) {
    padding: 2em 1em;
  }
}
</style>